export default __webpack_public_path__ + "static/media/swap-mobile.c3b47f0f.png";